import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@storybook/theming';
import { ShareLinks } from '../ShareLinks';

const SidebarInner = styled.aside`
  max-width: 100px;
  position: sticky;
  top: 3rem;
`;

export const PostSidebar = ({ shareText, link, authorTwitter }) => (
  <SidebarInner>
    <ShareLinks
      shareText={shareText}
      link={link}
      authorTwitter={authorTwitter}
      axis="vertical"
    />
  </SidebarInner>
);

PostSidebar.propTypes = {
  shareText: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  authorTwitter: PropTypes.string,
};

PostSidebar.defaultProps = {
  authorTwitter: undefined,
};
